import { z } from 'zod'

/** Messaggi WebSocket per stanza torneo: dicono cosa rileggere, non portano dati. */
export const LIVE_TYPES = ['tournament', 'match', 'event', 'timer', 'coins', 'bets'] as const
export type LiveType = (typeof LIVE_TYPES)[number]

export const LiveMessageSchema = z.object({
  type: z.enum(LIVE_TYPES),
  tournamentId: z.string(),
  matchId: z.string().optional(),
  at: z.string(),
})
export type LiveMessage = z.infer<typeof LiveMessageSchema>
